var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlyamamaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #05026d;\n      }\n\n      .st1 {\n        fill: #02a43f;\n      }\n\n      .st2 {\n        fill: #727773;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M933.85,159.22c168.25-22.76,259.73,182.86,129.38,287.6-117.91,94.74-292.45-10.94-262.25-160.07,12.58-62.12,69.24-118.92,132.87-127.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1162.08,329.77h82.4v323.18c0,.35-92.29.19-92.29-.16v-125.39c-181.68,154.47-465.44,44.28-474.65-197.63h83.51s1.42,17.05,3.65,26.56c54.59,232.97,380.07,205.84,397.37-26.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1381.17,649.51l1.76,98.88h-118.66l-.81-76.08-26.59,26.64v48.74l-73.04-.51-.12-69.09-135.11,1.08c-3.86,0-18.13,14.24-18.13,18.13v51.09l-84.02-1.01v-95.57s-26.3,0-26.3,0v98.38c0,5.11,19.25,17.98,22.97,17.98h484.45v-118.66h-26.4ZM1134.05,747.43h-98.59s0-49.57,0-49.57h98.85c-1.09,8.04-.26,49.57-.26,49.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M731.93,679.17c-1.55,0-18.13,14.34-18.13,18.13v51.09h-98.88v-69.22h-133.49c-4.22,0-21.43,14.04-21.43,18.13v70.87h408.72v-89h-136.79ZM588.55,748.39h-98.88v-49.44h98.88v49.44ZM837.56,747.26h-95.56v-49.52h95.81l-.25,49.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1433.6,
    y: 650.84,
    width: 26.4,
    height: 117.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 486.12,
    y: 641.42,
    width: 128.66,
    height: 16.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1185.06,
    y: 785.02,
    width: 128.66,
    height: 16.96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564.22,824.4h-67.5c-12.29,0-21.49,4.12-27.58,12.35-6.09,8.23-9.14,20.47-9.14,36.72v49.06h22.88v-17.45h58.45v17.45h22.89v-98.13ZM482.88,868.85c0-2.41.28-5.05.82-7.9.55-2.85,1.51-5.54,2.88-8.07,1.37-2.52,3.29-4.64,5.76-6.34,2.47-1.7,5.57-2.55,9.3-2.55h39.68v41.49h-58.45v-16.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M677.5,922.53h-45.94c-9.11,0-16.91-.63-23.38-1.89-6.48-1.26-11.77-3.21-15.89-5.84-4.12-2.63-7.14-6.04-9.06-10.21-1.92-4.17-2.88-9.16-2.88-14.98v-65.2h22.89v59.64c0,2.85.41,5.45,1.23,7.81.82,2.36,2.28,4.36,4.36,6,2.08,1.64,4.96,2.9,8.64,3.78,3.68.88,8.37,1.31,14.08,1.31h45.94v19.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M794.52,873.46c0,16.25-3.05,28.48-9.14,36.72-6.09,8.23-15.29,12.35-27.58,12.35h-48.9v-19.59h44.29c3.07,0,5.71-.6,7.9-1.81,2.19-1.21,4.01-2.74,5.43-4.61,1.42-1.87,2.5-3.98,3.21-6.34.71-2.36,1.18-4.69,1.4-7h-44.12c-12.3,0-21.49-4.12-27.58-12.35s-9.14-20.47-9.14-36.72v-9.71h22.89v14.32c0,2.42.27,5.05.82,7.9.55,2.86,1.51,5.54,2.88,8.07,1.37,2.53,3.27,4.64,5.68,6.34,2.41,1.7,5.54,2.55,9.39,2.55h39.68v-39.19h22.89v49.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M916.74,824.4h-67.5c-12.29,0-21.49,4.12-27.58,12.35-6.09,8.23-9.14,20.47-9.14,36.72v49.06h22.89v-17.45h58.45v17.45h22.89v-98.13ZM835.41,868.85c0-2.41.28-5.05.82-7.9.55-2.85,1.51-5.54,2.88-8.07,1.37-2.52,3.29-4.64,5.76-6.34,2.47-1.7,5.57-2.55,9.3-2.55h39.68v41.49h-58.45v-16.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1063.26,857.32v65.2h-22.88v-59.65c0-2.84-.42-5.44-1.24-7.81-.81-2.31-2.24-4.28-4.26-5.91-8.66-2.76-21.96-1.81-21.96-1.81l.69,75.16h-29.55s-.44-57.33-.44-68.9c-4.37-8-26.96-6.26-26.96-6.26l.69,75.16h-29.6v-98.13h84.3c9.11,0,16.91.62,23.38,1.89,6.48,1.27,11.77,3.22,15.88,5.85.16.1.31.19.45.3,3.9,2.59,6.75,5.9,8.6,9.91,1.92,4.18,2.89,9.17,2.89,14.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1335.24,857.32v65.2h-22.88v-59.65c0-2.84-.42-5.44-1.24-7.81-.81-2.31-2.24-4.28-4.26-5.91-8.66-2.76-21.96-1.81-21.96-1.81l.69,75.16h-29.55s1.15-57.33,1.15-68.9c-4.37-8-28.55-6.26-28.55-6.26l.69,75.16h-29.6v-98.13h84.3c9.11,0,16.91.62,23.38,1.89,6.48,1.27,11.77,3.22,15.88,5.85.16.1.31.19.45.3,3.9,2.59,6.75,5.9,8.6,9.91,1.92,4.18,2.89,9.17,2.89,14.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1040.38,919.41v3.11h-.06s.02-1.14.06-3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1188.01,824.4h-67.5c-12.29,0-21.49,4.12-27.58,12.35-6.09,8.23-9.14,20.47-9.14,36.72v49.06h22.89v-17.45h58.45v17.45h22.89v-98.13ZM1106.67,868.85c0-2.41.28-5.05.82-7.9.55-2.85,1.51-5.54,2.88-8.07,1.37-2.52,3.29-4.64,5.76-6.34,2.47-1.7,5.57-2.55,9.3-2.55h39.68v41.49h-58.45v-16.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1355.78,824.4h67.5c12.29,0,21.49,4.12,27.58,12.35,6.09,8.23,9.14,20.47,9.14,36.72v49.06h-22.89v-17.45h-58.45v17.45h-22.89v-98.13ZM1437.11,868.85c0-2.41-.28-5.05-.82-7.9-.55-2.85-1.51-5.54-2.88-8.07-1.37-2.52-3.29-4.64-5.76-6.34-2.47-1.7-5.57-2.55-9.3-2.55h-39.68v41.49h58.45v-16.63Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlyamamaLogo);
export default __webpack_public_path__ + "static/media/alyamama_logo.f48b1b6af416b02f11c42a27b42dd54f.svg";
export { ForwardRef as ReactComponent };